@if (driver(); as driver) {
  <span>
    {{ driver.driverData | onyxName }}
  </span>
} @else {
  -
}
